
const globalDocument = document;
document.addEventListener('DOMContentLoaded', function() {
  document.querySelector('#checkout').addEventListener('click', function(event) {
  // Get cart HTML and parse it
    const cartItems = Array.from(document.querySelector('cart-items').querySelectorAll('.cart-item'));

    //filter out fee product
    const cartItemsWithoutFee = cartItems.filter(item => !item.dataset.isFee);

    // get shipping objects
    const shippingObjects = cartItemsWithoutFee.map(item => JSON.parse(item.dataset.productShipping || '{}'));

    // get product with only express shipping
    const hasNoShipping = shippingObjects.some(object => !object);

    const hasSomeExpressShippingOnly = shippingObjects.some(object => object && (parseInt(object.express_shipping_amount) > 0 || object.express_free_shipping) && parseInt(object.standard_shipping_amount) === 0 && !object.standard_free_shipping);

    // get product with standard shipping
    const hasStandardShipping = shippingObjects.some(object => object && parseInt(object.standard_shipping_amount) > 0 );
    
    console.log('hasSomeExpressShippingOnly', hasSomeExpressShippingOnly);
    console.log('hasStandardShipping', hasStandardShipping);
    console.log('hasNoShipping', hasNoShipping);
    if(hasSomeExpressShippingOnly && (hasStandardShipping || hasNoShipping)) {
      // get cart prompt toggler
      const cartPromptToggler = globalDocument.querySelector('#cart-prompt-modal')?.querySelector('details');
      cartPromptToggler.setAttribute('open', true);
      return;
    }
    gotoCheckout();
  });
})

function gotoCheckout() {
  const checkoutBtn = document.querySelector('#checkout');
  checkoutBtn?.setAttribute('type', 'submit');
  checkoutBtn?.click();
}